import React from "react";
import {
  Grid,
  CardContent,
  CardHeader,
  Card,
  Divider,
} from "@material-ui/core";
import { TradeByClientsReportTable } from "./TradeByClientsReportTable";
import { usePageStyles } from "../../../pageStyles";
import { PageComponent } from "../../../../core/navigation/types";
import { PageTitle } from "../../../components/common/PageTitle";
import { TradeByClientsReportFilter } from "./TradeByClientsReportFilter";
import { DownloadButton, DownloadExcelButton } from "./DownloadButton";

const TradeByClientsReport: PageComponent = ({ userAccessRights }) => {
  const pageStyles = usePageStyles();

  return (
    <>
      <Grid container className={pageStyles.root}>
        <Grid item xs={12} className={pageStyles.gridItem}>
          <Card>
            <CardHeader
              title={<PageTitle title="exchTurnoverByClient" />}
              action={<TradeByClientsReportActions />}
            />
            <Divider />
            <CardContent>
              <TradeByClientsReportTable userAccessRights={userAccessRights} />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export const TradeByClientsReportActions: React.FunctionComponent = () => (
  <Grid container>
    <Grid item>
      <TradeByClientsReportFilter />
    </Grid>
    <Grid item>
      <DownloadButton />
    </Grid>
    <Grid item>
      <DownloadExcelButton />
    </Grid>
  </Grid>
);

export default TradeByClientsReport;
